(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-rich-text"] && !window.DesignMode) return;
  try {
    
  class MealsCounter extends HTMLElement {
    constructor() {
      super();

      // Set the options for the IntersectionObserver
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };

      // Create a new IntersectionObserver instance with the callback function
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.animateCounter();
            observer.unobserve(entry.target);
          }
        });
      }, options);

      // Observe the target element with the IntersectionObserver
      observer.observe(this);
    }

    connectedCallback() {
      this.innerHTML = `<span class="meal-counter">0</span>`;
    }

    animateCounter() {
      const counter = this.querySelector('.meal-counter');
      const startDate = new Date('1/1/2015');
      const totalMeals = this.getTotalMeals(startDate);
      let value = 0;
      const duration = 3000; // Duration of the animation in milliseconds
      let startTimestamp = null;

      const step = timestamp => {
        if (!startTimestamp) {
          startTimestamp = timestamp;
        }
        const progress = timestamp - startTimestamp;
        const easing = easeInOutExaggerated(progress / duration); // Apply easing function
        value = Math.floor(easing * totalMeals);
        counter.innerHTML = this.numberWithCommas(value);

        if (progress < duration) {
          window.requestAnimationFrame(step);
        }
      };

      // Easing function
      const easeInOutExaggerated = t => {
        // Exaggeration factor
        const exaggeration = 2;

        // Apply easing function with exaggeration
        return t < 0.5 ? Math.pow(2 * t, exaggeration) / 2 : (2 - Math.pow(2 * (1 - t), exaggeration)) / 2;
      };

      window.requestAnimationFrame(step);
    }

    getTotalMeals(startDate) {
      const currentDate = new Date();
      const currentTime = currentDate.getHours() * 60 + currentDate.getMinutes();
      const mealsPerDay = 1714;

      // Calculate the total meals based on the elapsed days and current time
      const elapsedDays = Math.floor((currentDate.getTime() - startDate.getTime()) / (24 * 60 * 60 * 1000));
      let totalMeals = elapsedDays * mealsPerDay;

      // Adjust the total meals based on the current time
      totalMeals += Math.floor(mealsPerDay * (currentTime / (24 * 60)));

      return totalMeals;
    }

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }

  customElements.define('meals-counter', MealsCounter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-guarantees"] && !window.DesignMode) return;
  try {
    
  // page js comes here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"] && !window.DesignMode) return;
  try {
    
  // page js comes here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-calc"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function () {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection === null) {
      return;
    }

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open('GET', productRecommendationsSection.dataset.url);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector('.product-recommendations').innerHTML;
        theme.ProductBlockManager.loadImages(productRecommendationsSection);
        theme.initAnimateOnScroll();
      }
    };
    request.send();
  };

  // fetch when section reloads in editor
  document.addEventListener('shopify:section:load', function (event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
      loadProductRecommendationsIntoSection();
    }
  });

  // get select by class pet_chosen_product
  var petChosenProduct = document.querySelector('.pet_chosen_product');

  // add event listener to petChosenProduct and update data-url with new product ID
  petChosenProduct.addEventListener('change', function () {
    // get dom of hidden input #pet_chosen_product
    var petChosenProduct = document.getElementById('pet_chosen_product');
    var productID = petChosenProduct.value;

    if (productID === '') {
      return;
    }

    // get data-url from .product-recommendations
    var productRecommendationsSection = document.querySelector('.product-recommendations');
    var productRecommendationsSectionURL = productRecommendationsSection.dataset.url;

    // example 1: data-url="/recommendations/products?// section_id=template--16784591388911__recommendations-for-calc&limit=5&product_id=7925994062063"
    // update data-url with new product ID
    var newURL = productRecommendationsSectionURL.replace(/product_id=\d*/, 'product_id=' + productID);

    // update data-url
    productRecommendationsSection.dataset.url = newURL;

    // call function to update recommendations
    loadProductRecommendationsIntoSection();
  });

  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {

    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) {
      return;
    }

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", productRecommendationsSection.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
        theme.ProductBlockManager.loadImages(productRecommendationsSection);
        theme.initAnimateOnScroll();
      }
    };
    request.send();
  };

  // fetch when section reloads in editor
  document.addEventListener("shopify:section:load", function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
      loadProductRecommendationsIntoSection();
    }
  });

  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
